import React from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { SearchInput, FormHelpText, Button, Card } from '@offerzen/pinata-shame'

import ControlledHookField from '@/CandidateExperience/components/ControlledHookField'

import styles from './styles'

const JobSearch = ({ onSearchSubmit, searchTerms }) => {
  const { control, handleSubmit, setValue } = useForm({ defaultValues: { searchTerms } })

  return (
    <Card className={styles.card}>
      <form className={styles.jobForm} onSubmit={handleSubmit(onSearchSubmit)} role="search" aria-label="Available jobs">
        <div>
          <label htmlFor="job-search" className={styles.accessiblyHidden}>
            Job search
          </label>
          <ControlledHookField
            id="job-search"
            aria-describedby="job-search-helptext"
            name="searchTerms"
            control={control}
            component={SearchInput}
            className={styles.input}
            placeholder="JavaScript fullstack"
            onClear={() => setValue('searchTerms', '')}
          />

          <div id="job-search-helptext">
            <FormHelpText text="Search by skill, company or role" />
          </div>
        </div>

        <Button type="submit" variant="outlined" label="Find jobs" size="medium" />
      </form>
    </Card>
  )
}

JobSearch.propTypes = {
  onSearchSubmit: PropTypes.func,
}

export default JobSearch
